import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Container from "../components/Container";
import SectionTitle from "../components/Home/SectionTitle";
import { useSiteContent } from "../context/SiteContentContext";

const defaultContent = {
  hero: {
    eyebrow: "توثيق الرعية",
    title: "تاريخ الكنيسة",
    description:
      "ملخص تاريخ الكنيسة الجديدة والكنيسة القديمة كما ورد في الروايات المحلية المتداولة في البلدة.",
  },
  sections: [],
};

export default function History() {
  const [content, setContent] = useState(defaultContent);
  const { tables } = useSiteContent();

  useEffect(() => {
    fetch("/data/history.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`تعذر تحميل تاريخ الكنيسة: ${response.status}`);
        }

        return response.json();
      })
      .then((json) => {
        setContent({
          ...defaultContent,
          ...json,
          hero: {
            ...defaultContent.hero,
            ...json.hero,
          },
          sections: json.sections ?? defaultContent.sections,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <main className="pb-20">
      <section className="pb-8 pt-10">
        <Container>
          <div className="rounded-[32px] bg-[#f3eee5] px-6 py-10 text-right md:px-10 lg:flex lg:items-end lg:justify-between">
            <div className="max-w-3xl">
              <p className="text-sm font-bold text-[#8a7355]">
                {content.hero.eyebrow}
              </p>
              <SectionTitle
                title={content.hero.title}
                classes="mt-3 text-[#3e352b]"
              />
              <p className="mt-4 max-w-2xl text-[16px] leading-7 text-[#5d5348]">
                {content.hero.description}
              </p>
            </div>

            <Link
              to="/"
              className="mt-6 inline-flex rounded-full border border-[#8a7355] px-5 py-3 text-sm font-bold text-[#5d5348] transition-colors hover:bg-[#8a7355] hover:text-white lg:mt-0"
            >
              {tables.backHomeLabel}
            </Link>
          </div>
        </Container>
      </section>

      <section>
        <Container>
          <div className="space-y-6">
            {content.sections.map((section, index) => (
              <article
                key={section.title}
                className={`rounded-[32px] border border-[#eadfce] p-6 text-right shadow-[0_18px_60px_rgba(76,58,37,0.08)] md:p-8 ${
                  index === 0 ? "bg-white" : "bg-[#faf6ef]"
                }`}
              >
                <h2 className="text-[30px] font-bold text-[#3e352b]">
                  {section.title}
                </h2>

                <div className="mt-5 space-y-4 text-[16px] leading-8 text-[#5d5348]">
                  {section.paragraphs?.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>

                {section.details?.length ? (
                  <ul className="mt-6 space-y-3 text-[16px] leading-8 text-[#5d5348]">
                    {section.details.map((detail) => (
                      <li key={detail} className="relative pr-6">
                        <span className="absolute right-0 top-[14px] h-2 w-2 rounded-full bg-[#8a7355]" />
                        {detail}
                      </li>
                    ))}
                  </ul>
                ) : null}

                {section.note ? (
                  <p className="mt-6 rounded-[22px] bg-[#f4ede2] px-5 py-4 text-sm leading-7 text-[#6b5e51]">
                    {section.note}
                  </p>
                ) : null}
              </article>
            ))}
          </div>
        </Container>
      </section>
    </main>
  );
}
